import { Typography } from "../typography";
import { useLabel, UseLabelProps } from "./use-label";

export type LabelProps = UseLabelProps;

export const Label = (props: LabelProps) => {
  const { className, children, styles, componentProps } = useLabel(props);

  return (
    <Typography
      className={styles.base({ className })}
      as="label"
      fontSize="body-sm"
      spacing="widest"
      fontWeight="bold"
      uppercase
      {...componentProps}
    >
      {children}
    </Typography>
  );
};
